function getCode(value: unknown): string | undefined {
    if (typeof value === "string") {
        return value;
    }
    if (!value) {
        return;
    }
    const { code } = value as {code: unknown; };
    if (typeof code !== "string") {
        return;
    }
    return code;
}

function getLanguage(value: unknown): string | undefined {
    if (!value) {
        return;
    }
    const { language } = value as {language: unknown; };
    if (typeof language !== "string") {
        return;
    }
    return language;
}

export class CodeSnippet {
    constructor(
        public name: string,
        public code: string,
        public language?: string
    ) {
    }

    static fromUnknown(value: unknown, name: string) {
        const code = getCode(value);

        if (typeof code === "string") {
            return new CodeSnippet(name, code, getLanguage(value));
        }
    }
}

